import { AnimatePresence, motion } from "framer-motion";
import { FC, useEffect, useState } from "react";
import { SheetClose } from "~/components/ui/sheet";
import useAuthRoute from "~/hook/useAuthRoute";
import { useFontStyle } from "~/hook/useFontStyle";
import { getSession, setSession } from "~/lib/helperFuncation/sessionStorageService";
import { fadeVariants, touchVariants } from "~/lib/motion-obj";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_URL, SELECTED_ITEM } from "~/utils/constant";
import { formatName, wantsMobile } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "./type";

const MobileIconItem: FC<PropsType> = ({ data, category_name, shape, isImagePreloaded }) => {
  const [selectedIcon, setSelectedIcon] = useState<number | null>(getSession(SELECTED_ITEM) || null);
  const { medium, regular } = useFontStyle();
  const { handleNavigate } = useAuthRoute();

  useEffect(() => {
    setSession(SELECTED_ITEM, JSON.stringify(selectedIcon));
  }, [selectedIcon]);

  return (
    <div className="px-2">
      {category_name && (
        <div className="px-3 my-2 ">
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}
      <div className="grid grid-cols-3 xs:grid-cols-2 smd:grid-cols-3 md:grid-cols-3 justify-center">
        <AnimatePresence>
          {data.map((item) => {
            const isSelected = Number(selectedIcon) === item.id;
            const isVisible = wantsMobile(item.show_menu);
            return (
              isVisible && (
                <div
                  key={item.id}
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                >
                  <motion.div
                    variants={fadeVariants}
                    initial="hidden"
                    animate="visible"
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className={cn("flex items-center justify-center gap-2 py-2", isSelected && "bg-secondaryColor rounded-lg ")}
                    onClick={() => setSelectedIcon(item.id)}
                  >
                    <SheetClose>
                      <motion.div
                        variants={touchVariants}
                        initial="initial"
                        whileTap="tap"
                        // className="flex flex-col items-center justify-start gap-y-2 smd:w-[90px] sml:w-[100px]"
                        className="flex flex-col items-center justify-start"
                      >
                        <div className="flex icon-menu-image-parent items-center justify-center ">
                          <ImageWithSkeleton
                            url={{
                              small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                              medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                              large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                              hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                              original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                            }}
                            alt={item.name ?? "Icon"}
                            className={cn("icon-menu-image")}
                            loadImageLazy={false}
                            isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                            useSkeletonLoader={true}
                          />
                        </div>
                        <p className={cn("icon_category_name", regular)}>{item.name}</p>
                        {/* <p className={cn("icon_category_name", regular)}>{formatName(item.name)}</p> */}
                      </motion.div>
                    </SheetClose>
                  </motion.div>
                </div>
              )
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default MobileIconItem;
